import { createMuiTheme, responsiveFontSizes } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles/colorManipulator";

const grey200 = "#A4A9C5";
const grey700 = "#323856";
const divider = alpha("#414970", 0.5);

export const darkThemeOptions = {
  palette: {
    type: "dark",
    text: {
      primary: "#E5E6EC",
      secondary: "#8B92B6",
      hint: "#545A78",
      disabled: alpha("#a3b0ec", 0.4)
    },
    action: {
      active: "#E0E0E0",
      hover: "#20243A",
      selected: alpha("#000000", 0.08),
      selectedOpacity: 0.08, // does not produce desired effect
      disabled: alpha("#CED3FF", 0.4),
      disabledBackground: alpha("#B6BADC", 0.3)
    },
    primary: {
      main: "#1AD1DB",
      dark: "#009FA9",
      light: "#6CFFFF",
      contrastText: "#070A1B"
    },
    secondary: {
      main: "#7E67F3",
      dark: "#4F43CD",
      light: "#A583FF",
      contrastText: "#070A1B"
    },
    success: {
      main: "#3AC3A2",
      dark: "#009273",
      light: "#75F6D3",
      contrastText: alpha("#070a1b", 0.9)
    },
    info: {
      main: "#1AD1DB",
      dark: "#009FA9",
      light: "#009FA9",
      contrastText: alpha("#070a1b", 0.9)
    },
    warning: {
      main: "#FFD582",
      dark: "#CA931D",
      light: "#FFFFB3",
      contrastText: alpha("#070a1b", 0.9)
    },
    error: {
      main: "#FB5B8B",
      dark: "#C3205E",
      light: "#FF8FBB",
      contrastText: alpha("#070a1b", 0.9)
    },
    background: {
      default: "#070A1B",
      paper: "#13172A"
    },
    divider, // used for borders
    grey: {
      "50": "#F2F4FF",
      "100": "#CACDDB",
      "200": grey200,
      "300": "#8B92B6",
      "400": "#8B92B6",
      "500": "#6B7294",
      "600": "#545A78",
      "700": grey700,
      "800": "#1E233B",
      "900": "#13172A",
      // A100: '#D5D5D5',
      // A200: '#AAAAAA',
      // A400: '#616161',
      // A700: '#303030',
      A1000: "#070A1B"
    },
    accent: {
      100: "#47DAE2",
      200: "#5F7BFF",
      300: "#7E67F3",
      400: "#E05CDB",
      500: "#F56C75",
      600: "#FFD582",
      700: "#00B674"
    }
  },
  overrides: {
    MuiDialogTitle: {
      root: {
        borderBottomColor: divider
      }
    },
    MuiDialogActions: {
      root: {
        borderTopColor: divider
      }
    },
    MuiDivider: {
      light: {
        backgroundColor: "#4A4C65"
      }
    },
    MuiTableHead: {
      root: {
        background: alpha(grey700, 0.2)
      }
    },
    MuiTableCell: {
      root: {
        borderBottomColor: divider
      },
      head: {
        color: grey200
      }
    },
    MuiMenu: {
      paper: {
        borderColor: divider
      }
    }
  }
};

const darkTheme = responsiveFontSizes(createMuiTheme(darkThemeOptions));

const createTheme = (paletteType) => darkTheme;

export const useTheme = () => createTheme("dark");
